import {  MenuItem, MenuList, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useContext, useMemo, useState } from 'react';
import ContextMenu from '../ContextMenu/ContextMenu';
import ErrorModal from '../ItemProperties/Forms/FieldDataValidation/ErrorModal';
import { getNewRecordName } from './ContextActions/NewRecord';
import { treeActions } from '../../redux/slices/treeSlice';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genKey } from '../../utils/utilFunctions';
import CopyAndPasteXML from './ContextActions/CopyAndPasteXML';

function BlankXMLMenu(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const parentScreen = useContext(ParentScreenCtx);
    const type = useSelector((state) => state.treeData[parentScreen].leftTree.tree.body.selectedNode?.type);
    const { tree, currentTab } = useSelector((state) => state.treeData[parentScreen].rightTree);
    const templateHeader = useSelector((state) => state.treeData[parentScreen].rightTree.tree.templateHeader);
    const [errorModal, setErrorModal] = useState(false);
    const {isCopied,setIsCopied} = props;

    const handleErrorModal = () => {
        setErrorModal(false);
    }

    const showMenu =  useMemo(() => {
        //Checking if template is Empty or Not.
        const isTemplateEmpty =
            currentTab === "body"
                ? tree[currentTab]?.translatedData[0]?.children?.length === 0 ||
                tree[currentTab].selectedNode.ICON_DISPLAY === "TEMPLATE_BODY_DOTS"
                : tree[currentTab]?.translatedData?.length === 0;

        //Checking if body node is Selected or not;
        const nodeSelected = currentTab === "body" ? Object.keys(tree[currentTab].selectedNode).length > 0 : true;
        return isTemplateEmpty && nodeSelected
    }, [tree[currentTab]?.translatedData,tree[currentTab].selectedNode]);

    const isNotEmpty = () => {
        return currentTab === 'body' ? tree[currentTab].selectedNode.ICON_DISPLAY === "TEMPLATE_BODY_DOTS" &&
                tree[currentTab]?.translatedData[0]?.children?.length > 0 : false;
    }

    const getNewElement = () => {
        const rightChildArray = tree.body.translatedData[0].children;

        //If it is empty so it will make first node with 'ib-0' key
        if (!rightChildArray.length) return { key: 'ib-0-0', title: 'UNNAMED' };

        const lastElementKey = rightChildArray[rightChildArray.length - 1]?.split('-');
        lastElementKey[lastElementKey.length - 1] = Number(rightChildArray.length);
        const newElementKey = lastElementKey?.join('-');

        return { key: newElementKey, title: 'UNNAMED' };
    }

    // Creating a new element in redux
    const createElement = () => {
        const elementDetail = currentTab === 'body' ? getNewElement() : { key:"ib-0", title: getNewRecordName(tree) };
        const titleType = currentTab.charAt(0).toUpperCase() + currentTab.substr(1).toLowerCase();
        const title = elementDetail.title + (currentTab!='body' ? `_${titleType}` : "");

        const newElement = {
            nodeId:genKey(elementDetail.title),
            GUI_XML_SORT_ORDER: "1",
            ICON_DISPLAY: 'ELEMENT',
            // DESCRIPTION: title,
            // LENGTH: 0,
            TYPE: title,
            children: [],
            key: elementDetail.key,
            title: `<${title}>`,
            type: 'ELEMENT',
            // elementType: 'root',
            FIELDTYPE: "ALPHA"
        }

        dispatch(treeActions.setNewNode({ screen: parentScreen, type: currentTab, data: newElement }));
        dispatch(treeActions.setRightTreeSelectedNode({ screen: parentScreen, type: currentTab, data: newElement }));
    }

    const handleClick = () => {
        if (isNotEmpty()) {
            setErrorModal(true);
        } else {
            createElement();
        }
    }

    return (
        <>
            {["inboundTemplate", "outboundTemplate", "workflow"].includes(type) &&
                showMenu &&
                !Array.isArray(templateHeader) ? (
                <ContextMenu targetId="rightTree">
                    <Paper elevation={3} sx={{ width: "19rem" }}>
                        <MenuList>
                            <MenuItem name={t("MNU_NEW_ELEM")} onClick={handleClick}>
                                <span className={"ELEMENT"}></span>
                                <span className={"margin-left-8"}>{t("MNU_NEW_ELEM")}</span>
                            </MenuItem>
                            {isCopied?.copy && <MenuItem name={t("MNU_PASTE")} onClick={() => setIsCopied({ ...isCopied, paste: true,dispatchFrom:'BlankXMLMenu',treeType:parentScreen })}>
                                <span className={"DOCUMENT"}></span>
                                <span className={"margin-left-8"}>{t("MNU_PASTE")}</span>
                            </MenuItem>}
                        </MenuList>
                    </Paper>
                </ContextMenu>
            ) : (
                ""
            )}
            {
                errorModal && <ErrorModal
                errorModal={errorModal}
                handleErrorModal={handleErrorModal}
                errorMessage={t('BOX_XML_HAS_SINGLE_ROOT_ELEM__CREATE_ELEM_BELOW_THIS_ROOT')} />
            }
      {/* <CopyAndPasteXML isCopied={isCopied} setIsCopied={setIsCopied} contextMenuType={isCopied?.dispatchFrom === "keyPress" ? isCopied?.dispatchFrom : "BlankXMLMenu"} treeType={parentScreen}/> */}

        </>
    )
}

export default BlankXMLMenu